import './tag.scss';
import { navigate } from 'gatsby';
import * as React from 'react';
import { LazyCosmosImage } from './media/cosmosImage';
export const Tag = ({ iconTicket, content, to }) => {
    const onClick = React.useCallback((event) => {
        if (to) {
            navigate(to);
            event.preventDefault();
            event.stopPropagation();
        }
    }, []);
    return (<div className="tag" onClick={onClick}>
      {iconTicket && <LazyCosmosImage alt={content} ticket={iconTicket} aria-hidden="true"/>}
      <p>{content}</p>
    </div>);
};
